import { createDispatchRefresh } from './dispatchRefresh';

export function readWazeAlerts(response) {
  const items = response?.data;
  if (response?.status !== 200 || !Array.isArray(items) || items.some(item =>
    !item || !Number.isSafeInteger(item.id) || item.id <= 0 || typeof item.uuid !== 'string' ||
    !Number.isFinite(item.latitude) || !Number.isFinite(item.longitude) ||
    Math.abs(item.latitude) > 90 || Math.abs(item.longitude) > 180 ||
    !['active', 'dispatched'].includes(item.status))) {
    throw new Error('Waze refresh was incomplete. Showing the last received alerts.');
  }
  if (new Set(items.map(item => item.id)).size !== items.length)
    throw new Error('Waze refresh contained duplicate alerts. Showing the last received alerts.');
  return items;
}

export function shouldRefreshWaze(reason) {
  return reason === 'initial' || reason === 'incident-archived' ||
    (typeof reason === 'string' && reason.startsWith('waze-'));
}

export function createWazeRefresh({ api, currentSession, apply }) {
  return createDispatchRefresh({
    currentSession,
    load: async () => readWazeAlerts(await api.get('/waze/alerts', { timeout: 15000 })),
    apply,
  });
}
